import { onError } from '@apollo/client/link/error';

import { mittInstance } from '@/constants/mitt-instance';

// 多个请求可能同时失败，这里做节流，避免同一次故障弹出一串提示
const NOTIFY_INTERVAL = 10000;
let lastNotifiedAt = 0;

/**
 * 判断是否为需要提示用户刷新的网络层故障。
 * 403 一般是 CDN/WAF 拦截，429 是限流，5xx 是服务端异常，
 * 没有 statusCode 则通常是断网或请求被中断。
 */
const shouldNotifyUser = networkError => {
  const statusCode = networkError?.statusCode;

  if (typeof statusCode !== 'number') {
    return true;
  }

  return statusCode === 403 || statusCode === 429 || statusCode >= 500;
};

/**
 * 必须放在 RetryLink 上游：这里收到的是重试全部失败后的最终错误，
 * 偶发失败被重试救回来时不会误弹“刷新页面”的提示。
 */
export default function createNetworkErrorNotifyLink() {
  return onError(({ networkError }) => {
    if (!networkError || typeof window === 'undefined') {
      return;
    }

    if (!shouldNotifyUser(networkError)) {
      return;
    }

    const now = Date.now();

    if (now - lastNotifiedAt < NOTIFY_INTERVAL) {
      return;
    }

    lastNotifiedAt = now;

    mittInstance.emit('NETWORK_ERROR', {
      statusCode: networkError?.statusCode,
    });
  });
}
